import axiosPrivate from "../api/axiosPrivate";

export const getUserProfile = () => 
  axiosPrivate.get("/users/profile");

export const updateUserProfile = (data) => 
  axiosPrivate.put("/users/profile", data);


export async function getCards({ page = 1, items_per_page = 20 } = {}) {
  const response = await axiosPrivate.get("card-mgt/cards/virtual/list", {
    params: { page, items_per_page }
  });
  return response.data;
}

export async function createVirtualCard({ transaction_pin }) {
  const response = await axiosPrivate.post(
    "card-mgt/cards/virtual/create",
    { transaction_pin },
  );
  return response.data;
}

export async function initiateCardFunding({
  source_wallet_number_or_uuid,
  virtual_card_id,
  funding_amount,
}) {
  const response = await axiosPrivate.post(
    "card-mgt/cards/virtual/funding/initiate",
    { source_wallet_number_or_uuid, virtual_card_id, funding_amount },
  );
  return response.data;
}

export async function processCardFunding({
  source_wallet_number_or_uuid,
  funding_amount,
  virtual_card_id,
  transaction_pin,
}) {
  const response = await axiosPrivate.post(
    "card-mgt/cards/virtual/funding/process",
    {
      source_wallet_number_or_uuid,
      funding_amount,
      virtual_card_id,
      transaction_pin,
    },
  );
  return response.data;
}

export async function blockCard(cardId) {
  const response = await axiosPrivate.patch(
    `card-mgt/cards/${cardId}/block`,
    {},
  );
  return response.data;
}

export async function unblockCard(cardId) {
  const response = await axiosPrivate.patch(
    `card-mgt/cards/${cardId}/unblock`,
    {},
  );
  return response.data;
}


export async function getVirtualCardBalance(cardId) {
  const response = await axiosPrivate.get(
    `card-mgt/cards/virtual/${cardId}/balance`,
  );
  return response.data;
}

export async function getVirtualCardDetails(cardId) {
  const response = await axiosPrivate.get("card-mgt/cards/virtual/list");
  // Find the specific card from the response
  const cards = response.data?.data?.data || [];
  const card = cards.find((c) => c.id === cardId);
  return {
    status: true,
    message: "Card details retrieved successfully",
    data: card || null,
  };
}